<h2 mat-dialog-title>{{ data.config?.title ?? "MedInThePocket" }}</h2>
<div mat-dialog-content>
	<div
		class="text-xl"
		style="min-width: 300px">
		{{ data.message }}
	</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ data.config?.negativeButton ?? "core.close" | translate }}
	</button>
	@if (data.config?.positiveButton) {
		<button
			mat-button
			mat-dialog-close="true"
			[color]="getColor()">
			{{ $safeNavigationMigration(data.config?.positiveButton) | translate }}
		</button>
	}
</div>
